import React from 'react';
import SymptomSpecialityMappingSection from '../../components/MasterAdmin/SymptomSpecialityMappingSection';

const SymptomSpecialityMappingsPage: React.FC = () => {
  return (
    <div className="p-4 md:p-6 lg:p-8 max-w-[1400px] mx-auto bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 mt-6">
      <SymptomSpecialityMappingSection />
    </div>
  );
};

export default SymptomSpecialityMappingsPage;
